import { GridSchema } from "../common/grid-schema.model";

export class TierDTO {
  id: number;
  name: string;
  description?: string;
  storeChannelId: number;
  isArchived: boolean;
  includeVariantsWithoutTiers: boolean;
  constructor(init?: TierDTO) {
    Object.assign(this, init);
  }
}

export enum TierAvailabilityStatus {
  actives = 1,
  archived = 2
}

export class TierVM extends TierDTO {
  createdOn?: string;
  createdBy?: string;
  variant?: TierVariantVm;
  constructor(init?: TierVM) {
    super();
    Object.assign(this, init);
  }
}

export class TierVariantVm {
  current: number[];
  cache: number[];
  constructor(init?: TierVariantVm) {
    Object.assign(this, init);
    if (!this.current) this.current = [];
    if (!this.cache) this.cache = [];
  }
}

export class ProductTier extends TierDTO {
  public checked: boolean;
  constructor(init?: ProductTier) {
    super();
    Object.assign(this, init);
    if (this.checked === undefined) this.checked = false;
  }
}



export interface GridTierSchema<T> extends GridSchema<T> {
  status?: TierAvailabilityStatus;
  channelId?: number;
};

export class TierMultiSelectVM extends TierVM {
  checked: boolean;
  constructor(init?: TierMultiSelectVM) {
    super();
    Object.assign(this, init);
  }
}

